<template>
  <div class="premission_index">
    <el-row class="elAdd">
      <button
        type="primary"
        class="add"
        icon="el-icon-plus"
        @click="dialogFormVisible = true"
        >新增</button
      >
      <!-- <div class="search_div">
        <el-input
          v-model="keywords"
          class="search_input"
          size="medium "
          placeholder="请输入搜索内容"
          prefix-icon="el-icon-search"
        />
        <el-button type="primary" @click="getAnnounceList()">搜索</el-button>
      </div> -->
    </el-row>
    <!-- 表格 -->
    <el-table
      class="premission_table"
      :data="tableDatas"
      :header-cell-style="{background: '#F9F9F9',color:'#999999'}"
      style="width: 100%"
    >
      <el-table-column type="index" label="序号" width="60" />
      <el-table-column prop="name" label="名称" />
      <el-table-column prop="times" label="操作时间" width="160" />
      <el-table-column prop="edittimes" label="修改时间" width="160" />
      <el-table-column label="操作" fixed="right" width="160">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            @click.stop="() => edit(scope.row)"
            >编辑</el-button
          >
          <el-button
            plain
            type="danger"
            size="mini"
            @click="deleteClick(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 展示列表 -->
    <!-- 分页 -->
    <div class="pagination" v-if="totalPage > 10">
      <el-pagination
        background=""
        layout="prev, pager, next"
        :total="totalPage"
        :current-page.sync="currentPage"
        @current-change="getAnnounceList(currentPage)"
      />
    </div>
    <!-- 添加弹框 -->
    <el-dialog
      top="15vh"
      title="新增"
      :visible.sync="dialogFormVisible"
      width="50%"
      :close-on-click-modal="false"
    >
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item
          prop="level"
          label="角色类型:"
          :label-width="formLabelWidth"
        >
          <el-select v-model="form.level" placeholder="请选择菜单类型">
            <el-option label="全部" value="1" />
            <el-option label="自定义" value="2" />
            <el-option label="本院" value="3" />
          </el-select>
          <!-- <el-radio v-model="form.model" :label="1">目录</el-radio>
          <el-radio v-model="form.model" :label="2">菜单</el-radio>
          <el-radio v-model="form.model" :label="3">权限</el-radio> -->
        </el-form-item>
        <el-form-item
          prop="name"
          label="角色名称:"
          :label-width="formLabelWidth"
        >
          <el-input
            placeholder="请输入节点名称"
            v-model="form.name"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item prop="remark" label="备注:" :label-width="formLabelWidth">
          <el-input
            type="textarea"
            :row="3"
            placeholder="请输入备注"
            v-model="form.remark"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item
          prop="pid"
          label="服务名称:"
          :label-width="formLabelWidth"
        >
          <el-row>
            <el-cascader
              :options="options"
              v-model="form.pid"
              :show-all-levels="true"
              clearable
              :props="{
                expandTrigger: 'hover',
                children: 'children',
                label: 'name',
                value: 'id',
                checkStrictly: true,
                emitPath: false,
              }"
              @change="handleChange"
            >
            </el-cascader>
          </el-row>
        </el-form-item> -->
        <!-- <div v-text="list"></div> -->
        <el-form-item
          v-if="this.form.level == 2"
          prop="list"
          label="选择医院:"
          :label-width="formLabelWidth"
        >
          <el-cascader
            :options="permissionOptions"
            v-model="list"
            :props="propd"
          ></el-cascader>
          <!-- <el-cascader
    :options="permissionOptions"
    :props="propss"
    clearable></el-cascader> -->
        </el-form-item>
        <el-form-item
          prop="menu_ids"
          label="选择菜单:"
          :label-width="formLabelWidth"
        >
          <!-- this.$refs.menusTree.getCheckedKeys() -->
          <el-tree
            ref="menusTree"
            :data="menuList"
            :check-on-click-node="true"
            show-checkbox
            node-key="id"
            :props="defaultProps"
            :default-checked-keys="keys"
            @check="getMenuIds"
            :check-strictly="isAllSelect"
          />
        </el-form-item>

        <!-- <el-form-item prop="icon" label="图标:" :label-width="formLabelWidth">
          <e-icon-picker v-model="form.icon" />
        </el-form-item> -->
        <!-- <el-form-item
          prop="visible"
          label="是否隐藏:"
          :label-width="formLabelWidth"
        >
          <el-switch
            v-model="form.visible"
            active-text="显示"
            inactive-text="隐藏"
            :active-value="true"
            :inactive-value="false"
          >
          </el-switch>
        </el-form-item> -->
        <!-- <el-form-item
          prop="index"
          label="排序号:"
          :label-width="formLabelWidth"
        >
          <el-input
            placeholder="请输入排序号"
            v-model="form.index"
            autocomplete="off"
          ></el-input>
        </el-form-item> -->
        <!-- <el-form-item
          prop="url"
          label="路由地址:"
          :label-width="formLabelWidth"
        >
          <el-input
            placeholder="请输入路由地址"
            v-model="form.url"
            autocomplete="off"
          ></el-input>
        </el-form-item> -->

        <!-- <el-form-item label="成员身份:" :label-width="formLabelWidth" prop="type">
          <el-select v-model="form.grade" placeholder="请选择">
            <el-option label="目录" :value="1"></el-option>
            <el-option label="菜单" :value="2"></el-option>
            <el-option label="权限" :value="3"></el-option>
          </el-select>
        </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="postForm">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 编辑弹框 -->
    <el-dialog
      top="15vh"
      title="编辑菜单"
      :visible.sync="dialogFormVisibleEdit"
      width="40%"
      :close-on-click-modal="false"
    >
      <el-form :model="formEdit" :rules="rules" ref="formEdit">
        <!-- <el-form-item prop="content" label="公告内容:" :label-width="formLabelWidth">
          <el-input type="textarea" :row="3" placeholder="请输入公告内容" v-model="formEdit.content" autocomplete="off"></el-input>
        </el-form-item> -->
        <el-form-item
          prop="level"
          label="角色类型:"
          :label-width="formLabelWidth"
        >
          <el-select v-model="formEdit.level" placeholder="请选择菜单类型">
            <el-option label="全部" value="1" />
            <el-option label="自定义" value="2" />
            <el-option label="本院" value="3" />
          </el-select>
          <!-- <el-radio v-model="formEdit.model" :label="1">目录</el-radio>
          <el-radio v-model="formEdit.model" :label="2">菜单</el-radio>
          <el-radio v-model="formEdit.model" :label="3">权限</el-radio> -->
        </el-form-item>
        <el-form-item
          prop="name"
          label="角色名称:"
          :label-width="formLabelWidth"
        >
          <el-input
            placeholder="请输入节点名称"
            v-model="formEdit.name"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item prop="remark" label="备注:" :label-width="formLabelWidth">
          <el-input
            type="textarea"
            :row="3"
            placeholder="请输入备注"
            v-model="formEdit.remark"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item
          prop="pid"
          label="服务名称:"
          :label-width="formLabelWidth"
        >
          <el-row>
            <el-cascader
              :options="options"
              v-model="formEdit.pid"
              :show-all-levels="true"
              clearable
              :props="{
                expandTrigger: 'hover',
                children: 'children',
                label: 'name',
                value: 'id',
                checkStrictly: true,
                emitPath: false,
              }"
              @change="handleChange"
            >
            </el-cascader>
          </el-row>
        </el-form-item> -->
        <!-- <div v-text="formEditlist"></div> -->
        <el-form-item
          v-if="this.formEdit.level == 2"
          prop="pstlist"
          label="选择医院:"
          :label-width="formLabelWidth"
        >
          <el-cascader
            :options="permissionOptions"
            v-model="formEditlist"
            :props="propd"
          ></el-cascader>
          <!-- <el-cascader
    :options="permissionOptions"
    :props="propss"
    clearable></el-cascader> -->
        </el-form-item>
        <el-form-item
          prop="menu_ids"
          label="选择菜单:"
          :label-width="formLabelWidth"
        >
          <!-- this.$refs.menusTree.getCheckedKeys() -->
          <el-tree
            ref="menusTreeEdit"
            :data="menuList"
            :check-on-click-node="true"
            show-checkbox
            node-key="id"
            :props="defaultProps"
            :default-checked-keys="aaa"
            @check="getMenuIdsEdit"
            :check-strictly="isAllSelect"
          />
        </el-form-item>
        <!-- <el-form-item
          prop="visible"
          label="是否隐藏:"
          :label-width="formLabelWidth"
        >
          <el-switch
            v-model="formEdit.visible"
            active-text="显示"
            inactive-text="隐藏"
            :active-value="true"
            :inactive-value="false"
          >
          </el-switch>
        </el-form-item> -->
        <!-- <el-form-item
          prop="index"
          label="排序号:"
          :label-width="formLabelWidth"
        >
          <el-input
            placeholder="请输入排序号"
            v-model="formEdit.index"
            autocomplete="off"
          ></el-input>
        </el-form-item> -->
        <!-- <el-form-item
          prop="url"
          label="路由地址:"
          :label-width="formLabelWidth"
        >
          <el-input
            placeholder="请输入路由地址"
            v-model="formEdit.url"
            autocomplete="off"
          ></el-input>
        </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisibleEdit = false">取 消</el-button>
        <el-button type="primary" @click="postFormEdit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import { addAnnounce, deleteAnnounce, editAnnounce, announceList } from '@/api/shop.js'

export default {
  name: "Premission",
  data() {
    return {
      aaa: "",
      listlist: "",
      keysEdit: [],
      tableDatas: [],
      menuList: "",
      propd: {
        multiple: true,
        label: "name",
        value: "id",
      },
      optionss: [
        {
          value: 1,
          label: "东南",
          children: [
            {
              value: 2,
              label: "上海",
              children: [
                { value: 3, label: "普陀" },
                { value: 4, label: "黄埔" },
                { value: 5, label: "徐汇" },
              ],
            },
            {
              value: 7,
              label: "江苏",
              children: [
                { value: 8, label: "南京" },
                { value: 9, label: "苏州" },
                { value: 10, label: "无锡" },
              ],
            },
            {
              value: 12,
              label: "浙江",
              children: [
                { value: 13, label: "杭州" },
                { value: 14, label: "宁波" },
                { value: 15, label: "嘉兴" },
              ],
            },
          ],
        },
        {
          value: 17,
          label: "西北",
          children: [
            {
              value: 18,
              label: "陕西",
              children: [
                { value: 19, label: "西安" },
                { value: 20, label: "延安" },
              ],
            },
            {
              value: 21,
              label: "新疆维吾尔族自治区",
              children: [
                { value: 22, label: "乌鲁木齐" },
                { value: 23, label: "克拉玛依" },
              ],
            },
          ],
        },
      ],
      propss: {
        multiple: true,
        children: "children",
        checkStrictly: true,
        label: "name",
        value: "name",
      },
      isAllSelect: false,
      keys: [],
      defaultProps: {
        children: "children",
        label: "name",
      },
      pstlist: "",
      permissionOptions: "",
      checkList: "",
      options: "",
      keywords: "",
      totalPage: 0,
      currentPage: 1,
      tableData: [],
      dialogFormVisible: false,
      dialogFormVisibleEdit: false,
      formLabelWidth: "120px",
      list: "",
      formEditlist: [],
      form: {
        // content:"",
        // visible: true,
        // index: "",
        // url: "",
        // pstlist:'',
        hospitalIds: "",
        pid: "",
        remark: "",
        // icon: "",
        name: "",
        grade: "",
        level: "",
        permissions: "",
      },
      formEdit: {
        id: "",
        // content:"",
        // visible: "",
        // index: "",
        hospitalIds: "",
        // url: "",
        // icon: "",
        name: "",
        grade: "",
        level: "",
        pid: "",
        remark: "",
        pstlist: "",
        permissions: "",
      },
      rules: {
        // content:[{ required: true, message: "请输入公告内容", trigger: "blur" }],
        name: [{ required: true, message: "请输入节点名称", trigger: "blur" }],
        level: [{ required: true, message: "请选择角色类型", trigger: "blur" }],
      },
    };
  },
  created() {
    this.getCdlist();
    this.getAnnounceList();
    this.getMenuLinkageList();
    this.getPermissionList();
  },
  methods: {
     time(time = +new Date()) {
      var date = new Date(time + 8 * 3600 * 1000);
      return date.toJSON().substr(0, 19).replace("T", " ").replace(/-/g, "-");
    },
    getMenuIdsEdit() {
      // let menuIds = this.$refs.menusTree.getCheckedKeys()
      // this.roleForm.menu_ids = menuIds
      if (Array.isArray(this.$refs.menusTreeEdit.getCheckedKeys())) {
        this.formEdit.permissions = this.$refs.menusTreeEdit
          .getCheckedKeys()
          .join();
      }
      console.log(this.formEdit.permissions);
    },
    getCdlist() {
      depot
        .post({
          url: "/backend/menu/getMenus",
          data: {},
        })
        .then((res) => {
          console.log(res);
          this.tableData = res.data;
          console.log(this.tableData);
          this.menuList = JSON.parse(JSON.stringify(res.data));
          // this.options.forEach((val, index) => {
          //   val.children.forEach((valus, index) => {
          //     delete valus.children;
          //   });
          //   // delete val.children
          // });
          console.log(this.menuList);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    edit(data) {
      // let { type, id, parent_id, title, icon, path, vue_route, permissions } = data
      console.log(data);
      this.dialogFormVisibleEdit = true;
      this.formEdit = data;
      this.formEditlister = data.hospitalIds.split(",");
      console.log(this.formEditlister);

      let len = this.formEditlister.length;
      let n = 1; //假设每行显示4个
      let lineNum = len % 1 === 0 ? len / 1: Math.floor(len / 1 + 1);
      this.formEditlist = [];
      for (let i = 0; i < lineNum; i++) {
        // slice() 方法返回一个从开始到结束（不包括结束）选择的数组的一部分浅拷贝到一个新数组对象。且原始数组不会被修改。
        let temp = this.formEditlister.slice(i * n, i * n + n);
        this.formEditlist.push(temp);
      }
      console.error(this.formEditlist);

      var str = "";
      data.permissions.map((item) => {
        str = str + item.menuId + ",";
        this.formEdit.permissions = str;
        this.aaa = this.formEdit.permissions.split(",");
      });
      // console.log(data.permissions);
      // this.formEditlist = arr.map(item => item.split(':'))
      // this.formEdit.pstlist = data.permissions;
      // console.log(this.formEdit);
      // menuDetail({
      //   sign: '111',
      //   token: sessionStorage.getItem('token'),
      //   id: data.id
      // })
      //   .then(res => {
      //     this.editForm = res.data
      //     this.editForm.sign = '111'
      //     this.editForm.token = sessionStorage.getItem('token')
      //   })
      //   .catch(err => {
      //     console.log(err)
      //   })
      // this.getMenuLinkageList(data.type)
    },
    getMenuIds() {
      // let menuIds = this.$refs.menusTree.getCheckedKeys()
      // this.roleForm.permissions = menuIds
      if (Array.isArray(this.$refs.menusTree.getCheckedKeys())) {
        console.log(this.$refs.menusTree.getCheckedKeys());
        this.form.permissions = this.$refs.menusTree.getCheckedKeys().join();
      }
      console.log(this.form.permissions);
    },
    deleteClick(val) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          depot
            .post({
              url: "/backend/role/delete",
              data: {
                id: val.id,
              },
            })
            .then((res) => {
              console.log(res);
              if (res.success == true) {
                this.$message({
                  message: "删除成功",
                  type: "success",
                });
                this.getMenuLinkageList();
                return;
              }
              this.$message({
                message: res.msg,
                type: "error",
              });
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.title.indexOf(value) !== -1;
    },
    handleChange() {
      console.log(this.value);
    },
    getMenuLinkageList(value) {
      // console.log(value);
      depot
        .post({
          url: "/backend/role/list",
          data: {},
        })
        .then((res) => {
          console.log(res);
          this.tableDatas = res.data.list;
           this.tableDatas.forEach((element) => {
            console.log(this.time(element.studyDatetime));
            element.times = this.time(element.creTime);
            element.edittimes = this.time(element.updTime);
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getPermissionList(value) {
      // console.log(value);
      depot
        .get({
          url: "/v1/hospital/listHospital",
          params: {
            token: sessionStorage.getItem("token"),
          },
        })
        .then((res) => {
          console.log(res.data);
          this.permissionOptions = res.data;
          console.error(this.permissionOptions);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getAnnounceList(page = 1, page_num = 10) {
      // announceList({
      //   keywords:this.keywords,
      //   page: page,
      //   page_num: page_num
      // }).then(res => {
      //   this.tableData = res.data.data
      //   this.totalPage = res.data.total
      // }).catch(err => {
      //   console.log(err)
      // })
    },
    postForm() {
      //  this.form.permissions.forEach((val, index) => {
      //       console.log(val);
      //       // delete val.children
      // });
      // let str = "";
      // for (var i = 0; i < this.permissions.length; i++) {
      //   str += this.permissions[i] + "|";
      //   var newlist = str.replace(/\,/g, ":");
      //   this.form.permissions = newlist.replace(/\|/g, ",");
      //   // this.form.permissions = this.form.permissions.substr(0,this.form.permissions.length-1);
      //   console.log(this.form.permissions);
      // }
      if (this.list) {
        console.log(this.list);
        this.form.hospitalIds = this.list
          .map((item) => item.join(":"))
          .join(",");
        console.log(this.list.map((item) => item.join(":")).join(","));
        console.log(this.form.hospitalIds);
      }
      this.$refs["form"].validate((valid) => {
        if (valid) {
          depot
            .post({
              url: "/backend/role/save",
              data: this.form,
            })
            .then((res) => {
              console.log(res);
              if (res.success == true) {
                this.$message({
                  message: "添加成功",
                  type: "success",
                });
                this.dialogFormVisible = false;
                this.getMenuLinkageList();
                return;
              }
              this.$message({
                message: "新增失败",
                type: "error",
              });
            })
            .catch((err) => {
              console.log(err);
            });
          // addAnnounce(this.form).then(res => {
          //   this.$message({
          //     message:res.message,
          //     type:"success",
          //     duration:2000
          //   })
          //   this.dialogFormVisible = false;
          //   this.getAnnounceList(this.currentPage);
          //   this.$refs["form"].resetFields();
          // }).catch(err => {
          //   console.log(err)
          // })
        }
      });
    },
    handleDelete(row) {
      this.$confirm("是否确认删除?", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteAnnounce({
            id: row.id,
          })
            .then((res) => {
              this.getAnnounceList(this.currentPage);
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch(() => {});
    },
    handleEdit(row) {
      let { id, name, grade, pid, remark, level } = row;
      this.formEdit.id = id;
      // this.formEdit.content = content
      this.formEdit.name = name;
      this.formEdit.pid = pid;
      this.formEdit.remark = remark;
      // this.formEdit.pstlist = pstlist;
      // this.formEdit.pstlist = permissions;
      // this.formEdit.visible = visible;
      // this.formEdit.index = index;
      // this.formEdit.url = url;
      this.formEdit.grade = grade;
      this.formEdit.level = level;
      this.dialogFormVisibleEdit = true;
    },
    postFormEdit() {
      console.log(this.formEditlist);
      if (this.formEditlist[0] != "") {
        this.formEdit.hospitalIds = this.formEditlist
          .map((item) => item.join(":"))
          .join(",");
        console.log(this.formEditlist.map((item) => item.join(":")).join(","));
        console.log(this.formEdit.hospitalIds);
      }
      this.$refs["formEdit"].validate((valid) => {
        if (valid) {
          depot
            .post({
              url: "/backend/role/update",
              data: this.formEdit,
            })
            .then((res) => {
              console.log(res);
              if (res.success == true) {
                this.$message({
                  message: res.data,
                  type: "success",
                });
                this.dialogFormVisibleEdit = false;
                this.getMenuLinkageList();
                return;
              }
              this.$message({
                message: "修改失败",
                type: "error",
              });
            })
            .catch((err) => {
              console.log(err);
            });
          // editAnnounce(this.formEdit)
          //   .then((res) => {
          //     this.$message({
          //       message: res.message,
          //       type: "success",
          //       duration: 2000,
          //     });
          //     this.dialogFormVisibleEdit = false;
          //     this.getAnnounceList(this.currentPage);
          //     this.$refs["formEdit"].resetFields();
          //   })
          //   .catch((err) => {
          //     console.log(err);
          //   });
        }
      });
    },
  },
};
</script>

<style scoped>
.premission_index {
  padding: 10px;
  background: #fff;
  margin-top: 10px;
}
.search_div {
  float: right;
}
.search_input {
  width: 220px;
}
.premission_table {
  margin-top: 10px;
}
.pagination_box {
}
.pagination {
  padding: 0 300px;
  margin-top: 20px;
  text-align: center;
}
.elAdd {
  margin-bottom: 10px;
}
.add {
  position: fixed;
  right: 20px;
  top:88px;
  font-size: 16px;
  width: 120px;
  font-weight: 400;
  height: 40px;
  background: #009b43;
  border: none;
  
}
</style>
<style >
.el-message-box__btns button:nth-child(2) {
    width: 120px;
    height: 40px;
    background: #009B43;
    font-size: 14px;
    font-weight: 500;
    border-radius: 4px;
    border: none;
    color: #fff;
}
.el-message-box__btns button:nth-child(1) {
    width: 120px;
    height: 40px;
    font-size: 14px;
    font-weight: 500;
    background: #EEEEEE;
    border-radius: 4px;
    border: none;
    color: #999999;
}
.add {
  position: fixed;
  right: 20px;
  top:88px;
  font-size: 16px;
  width: 120px;
  font-weight: 400;
  height: 40px;
  background: #009b43;
  border: none;
  color: #fff;
   moz-transition: all .4s ease-in-out;
    -o-transition: all .4s ease-in-out;
    -webkit-transition: all .4s ease-in-out;
    transition: all .4s ease-in-out;
    border-radius: 3px;
}

.add:hover {
  border-radius: 3px;
  background-image: linear-gradient(to right, #0ba360, #3cba92, #30dd8a, #2bb673);
  box-shadow: 0 4px 15px 0 rgba(23, 168, 108, 0.75);
   background-position: 100% 0;
    -o-transition: all .4s ease-in-out;
    -webkit-transition: all .4s ease-in-out;
    transition: all .4s ease-in-out;
}
</style>




// WEBPACK FOOTER //
// src/views/role/index.vue